import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box, Alert, CircularProgress } from '@mui/material';
import axios from 'axios';
import { api_url } from '../constants'; // Ensure this is correctly defined

const ContactUs = () => {
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMsg('');
        setLoading(true);

        try {
            const response = await axios.post(`${api_url}/api/users/delete-account-request`, {
                email,
                phoneNumber,
            });

            if (response.status === 200) {
                setSuccessMsg('Request submitted successfully!');
                setEmail('');
                setPhoneNumber('');
            } else {
                setError('Failed to submit request.');
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                setError('No user found with this email.');
            } else if (err.response && err.response.data?.message) {
                setError(err.response.data.message);
            } else {
                setError('Something went wrong. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xs" sx={{ mt: 8 }}>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography variant="h5" component="h1" gutterBottom>
                    Request Access to Delete Account
                </Typography>

                <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <TextField
                    label="Phone Number"
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    required
                />


                <Button
                    type="submit"
                    variant="contained"
                    color="error"
                    fullWidth
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={20} />}
                >
                    {loading ? 'Submitting...' : 'Submit Request'}
                </Button>

                {successMsg && <Alert severity="success">{successMsg}</Alert>}
                {error && <Alert severity="error">{error}</Alert>}
            </Box>
        </Container>
    );
};

export default ContactUs;
